export { default as ImageWithTitle } from './ImageWithTitle';
